import React from "react";
import Slider from "react-slick";
import { StarEmpty, StarFull, StarHalf } from "../../assets";

const FAKE_TESTIMONY_DATA= [
  {
    name: "Maimouna Ndiaye",
    job: "Assistante comptable freelance",
    quote: "“Rejoindre Wall Of Share a été une véritable opportunité pour moi. Grâce à cette plateforme, j'ai pu décrocher un poste au sein d'une entreprise française qui correspond parfaitement à mes aspirations professionnelles !”",
    rating: 3.5
  },
  {
    name: "Mamadou Bilya",
    job: "Graphiste 3D",
    quote: "“Je ne suis sur Wall of Share que depuis 2 mois et j'ai déjà décroché mon premier contrat. Tout est sécurisé et toutes les formalités se font à travers le site. C'est parfait pour quelqu'un comme moi.”",
    rating: 4
  },
  {
    name: "John Doe",
    job: "Data analyst",
    quote: "“Wall of Share is all I ever wanted. There are no fees for making a job application, no credit systems. You can create an account and look for a job right away !”",
    rating: 4.5
  },
  {
    name: "Matter Johnsonn",
    job: "Directeur technique",
    quote: "“Les workers sur Wall of Share ont les meilleurs rapport qualité-prix. La plateforme fournit tout ce dont on a besoin pour intéragir avec les freelance.”",
    rating: 5
  },
];

export default function SimpleSlider({render}:any) {
  var settings = {
    dots: true,
    className: "center",
    centerMode: true,
    centerPadding: "60px",
    infinite: true,
    speed: 500,
    arrows:false,
    slidesToShow: 1,
    initialSlide: 1,
    slidesToScroll: 1,
    dotsClass: 'slick-dots bigger-dots',
    appendDots: (dots: any) => (
        <ul className="slick-dots bigger-dots"> {dots} </ul>
    ),
  };
  
  return (
    <Slider {...settings}>
      {
        FAKE_TESTIMONY_DATA.map((testimony, key)=>(
          <SliderElement
            name= {testimony.name}
            job={testimony.job}
            quote= {testimony.quote}
            rating= {testimony.rating}
            key= {key}
          />)
        )
      }
    </Slider>
  );
}

function SliderElement ({name, job, quote, rating}: any) {
  return <>
    <div>
      <div>
        <div className="relative mt-8 grid h-[30rem] sm:h-[25rem] md:h-[20rem] grid-rows-[100%]">
            <div className="bg-[#1D1D39] left-0 right-0 z-10 xl:p-0 py-3 flex flex-col rounded-3xl  bg-no-repeat relative items-center justify-center">
              <img src="/images/flyer.png" alt="flyer logo" className="w-[11rem] absolute bottom-[2rem] right-0"/>
              <div className="text-white w-4/5 mx-auto flex flex-col justify-center">
                <div className="ratings flex flex-row">
                  {makeAlotOfStars(Math.floor(rating))}
                  {((rating - Math.floor(rating))>= .5) && <img src={StarHalf} alt="star full" />}
                </div>
                <div className="my-4 flex md:flex-row md:gap-3 flex-col">
                  <div className="text-[18px] lg:font-semibold">{name}</div>
                  <div className="text-[#BBBBC499] lg:font-normal">{job}</div>
                </div>
                <div className="lg:font-semibold lg:text-[25px] text-[20px]">
                  {quote}
                </div>
              </div>
              <div className="custom-gradient rounded-3xl transform absolute left-0 right-0 z-0 rotate-3 translate-x-1  bg-no-repeat h-[18rem]" />
            </div>
        </div>
      </div>
    </div>
  </>;
}

export function makeAlotOfStars(count: number) {
  const components= [];
  const starsCount= count > 5 ? 5 : count;
  for (let i= 0; i< starsCount; i++) {
    components.push(<img src={StarFull} alt="star full" key={`star-${i}`}/>);
  }
  return components;
}
export function makeAlotOfEmptyStars(count: number) {
  const components= [];
  for (let i= 0; i< count; i++) {
    components.push(<img src={StarEmpty} alt="star full" key={`starEmpty-${i}`}/>);
  }
  return components;
}